// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityOrganizationTree = {
  selectOrganization: "組織を選択",
  organizationsLoadFailed: "組織一覧の読み込みに失敗しました",
  treeLoadFailed: "組織ツリーの読み込みに失敗しました",
  membersLoadFailed: "ノードメンバーの読み込みに失敗しました",
  treeTitle: "組織ツリー",
  treeDescription:
    "左側で組織構造を管理し、ノード選択で右側のメンバーパネルを切り替え、各ノード行から子ノード追加・編集・メンバー追加を直接行えます。",
  searchPlaceholder: "ノード名で検索",
  dragDisabledDuringSearch:
    "検索フィルター中はドラッグ操作を無効化しています。ツリーを並べ替えるには検索をクリアしてください。",
  emptyTitle: "管理可能な組織がありません",
  emptyDescription: "まだ組織主体が存在しません。「最初の組織を作成」から初期化してください。",
  createFirstOrganization: "最初の組織を作成",
  bootstrapCreateTitle: "最初の組織を作成",
  noOrganization: "先に組織ノードを選択してください",
  organizationSummary: "組織概要",
  organizationSummaryHint: "この組織の実運用の構造とメンバー所属をここで管理します。",
  totalUnits: "総ノード数",
  totalMemberships: "総所属数",
  leafUnits: "末端ノード数",
  emptyLeafUnits: "空ノード数",
  subtreeUnits: "現在ノード配下のノード数",
  subtreeMemberships: "現在ノード配下の所属数",
  nodeDetails: "ノード詳細",
  nodeWorkbench: "ノード作業エリア",
  nodeMembers: "直属メンバー",
  addChild: "子ノードを追加",
  editNode: "ノードを編集",
  addMember: "メンバーを追加",
  deleteNode: "ノードを削除",
  deleteNodeTitle: "組織ノードを削除",
  deleteNodeDescription:
    "ノード {name} を削除しますか？配下ノードも直属メンバーもいない空ノードだけ削除できます。",
  deleteNodeConfirm: "ノードを削除",
  deleteNodeRootBlocked: "組織主体のルートノードは削除できません",
  deleteNodeChildrenBlocked: "先に配下ノードを整理してからこのノードを削除してください",
  deleteNodeMembersBlocked: "先に直属メンバーを外してからこのノードを削除してください",
  rootProtectedHint:
    "ルートノードは組織主体の真相から生成されます。ここでは配下への子ノード追加のみ可能で、直接の編集や移動はできません。",
  rootNode: "ルート",
  organizationHome: "組織主体",
  directMembersTag: "直属メンバー {count}",
  childNodesTag: "配下ノード {count}",
  selectedNodeLabel: "ノード名",
  organizationUnitKeyLabel: "ノード識別子",
  parentNodeLabel: "親ノード",
  childNodes: "直属子ノード数",
  directMembers: "直属メンバー数",
  pathLabel: "現在のパス: {path}",
  pathValueLabel: "ノードパス",
  organizationUnitLabel: "所属ノード",
  nodeSummaryRoot: "これは組織主体のルートノードで、全体構造の起点です。",
  nodeSummaryLeaf: "{name} にはまだ子ノードがなく、直接メンバーを所属させられます。",
  nodeSummaryBranch: "{name} にはすでに子ノードがあり、さらに細分化できます。",
  currentNodeEmptyHint:
    "このノードにはまだ子ノードも直属メンバーもありません。先に構造かメンバー所属を追加してください。",
  childUnits: "下位ノード",
  childUnitsHint: "ここから現在ノードの直属下位ノードをすばやく確認し、管理できます。",
  childUnitsEmptyTitle: "まだ下位ノードがありません",
  childUnitsEmptyDescription: "先に子ノードを作成してから、メンバー所属を追加してください。",
  childUnitLeafHint: "{name} は現在末端ノードで、直接メンバーを所属させられます。",
  childUnitBranchHint: "{name} にはまだ子ノードがあり、さらに階層を分けられます。",
  openNode: "ノードを開く",
  memberManagement: "メンバー管理",
  directMembersHint:
    "現在ノードへ直接所属するメンバーのみを表示し、精密な紐付け調整に向いています。",
  noParent: "なし",
  userStatus: "ユーザー状態",
  membershipStatus: "所属状態",
  removeMemberTitle: "組織メンバーを削除",
  removeMemberDescription: "{user} を {unit} から削除しますか？",
  memberRemoved: "組織メンバーを削除しました",
  memberRemoveFailed: "組織メンバーの削除に失敗しました",
  memberCreated: "組織メンバーを追加しました",
  memberCreateFailed: "組織メンバーの追加に失敗しました",
  nodeMoved: "組織ノードを移動しました",
  nodeMoveFailed: "組織ノードの移動に失敗しました",
  nodeDeleted: "組織ノードを削除しました",
  nodeDeleteFailed: "組織ノードの削除に失敗しました",
  unitCreateTitle: "組織ノードを作成",
  unitEditTitle: "組織ノードを編集",
  nodeCreated: "組織ノードを作成しました",
  nodeCreateFailed: "組織ノードの作成に失敗しました",
  nodeUpdated: "組織ノードを更新しました",
  nodeUpdateFailed: "組織ノードの更新に失敗しました",
  unitNameRequired: "ノード名を入力してください",
  organizationNameRequired: "組織名を入力してください",
  organizationKeyRequired: "組織キーを入力してください",
  userRequired: "対象ユーザーを選択してください",
  userSearchPlaceholder: "ユーザー名またはニックネームで検索",
} as const;
